import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TicketRefreshService {
  private refreshTicketSource = new Subject<boolean>();

  refreshTicket$ = this.refreshTicketSource.asObservable();

  triggerTicketRefresh(refresh: boolean) {
    this.refreshTicketSource.next(refresh);
  }
}
